export const WS_API_PATH = 'v5/endpoint-desktop/';
